import React, { useState } from "react";
import "./Contact.css";
import contactImg from "../images/About.jpg";
import { useForm } from 'react-hook-form';

const Contact = () => {
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  const [input3, setInput3] = useState("");
  const [input4, setInput4] = useState("");
  const [showForm, setShowForm] = useState(false); // New state for form visibility

  const {
    trigger,
  } = useForm();

  const onSubmit = async (e) => {
    const isValid = await trigger();
    if (!isValid) {
      e.preventDefault();
    }
  };

  const buttonHandler = () => {
    if (input1 === "" || input2 === " " || input3 === "" || input4 === "")
      return alert("Fill up form");
    
    if (input1 !== "" && input2 !== " " && input3 !== "" && input4 !== "")
      return alert("Submitted: " + input1 + " " + input2 + " " + input3 + " " + input4);
  };

  const input1Handler = (event) => {
    setInput1(event.target.value);
  };
  const input2Handler = (event) => {
    setInput2(event.target.value);
  };
  const input3Handler = (event) => {
    setInput3(event.target.value);
  };
  const input4Handler = (event) => {
    setInput4(event.target.value);
  };

  // Toggle form visibility
  const handleEmailClick = () => {
    setShowForm(!showForm);
  };

  return (
    <div className="contact-component__space" id="Contact">
      <div className="row">
        <div className="col__2">
          <div className="contact__box">
            <div className="contact__meta">
              <h1 className="hire__text">Book</h1>
            
              <p className="hire__text white">
                <a href="https://wa.me/27735851868?text=Hi%20Mobile%20Carwash%2C%20I%20am%20interested%20in%20your%20services" target="_blank" rel="noopener noreferrer">
                  <button className="about btn pointer">Via Whatsapp</button>
                </a>
              </p>
              <p className="hire__text white">
                <button className="about btn pointer" onClick={handleEmailClick}>
                  Via Email
                </button>
                <br/>
                <p className="hire__text white">
                <strong>Call: +27735851863</strong>
              </p>
                <a href="https://mail.google.com/"><strong>anesumuusha@gmail.com</strong></a>
              </p>

              {showForm && ( // Conditional rendering of the form
                <div className="input__box">
                  <form
                    target="_blank"
                    onSubmit={onSubmit}
                    action='https://formsubmit.co/anesumuusha@gmail.com'
                    method='POST'
                  >
                    <input
                      onChange={input1Handler}
                      value={input1}
                      name='username'
                      type="text"
                      id="userName"
                      className="contact name"
                      placeholder="Full name *"
                    />
                    <input
                      onChange={input2Handler}
                      value={input2}
                      name='email'
                      type="email"
                      id="email"
                      className="contact email"
                      placeholder="Email *"
                    />
                    <input
                      onChange={input3Handler}
                      value={input3}
                      name="subject"
                      type="number"
                      id="subject"
                      className="contact subject"
                      placeholder="Phone number"
                    />
                    <textarea
                      onChange={input4Handler}
                      value={input4}
                      name="message"
                      id="message"
                      placeholder="Date for car wash"
                    />
                    <button
                      onClick={buttonHandler}
                      className="about btn pointer"
                      type="submit"
                    >
                      Submit
                    </button>
                  </form>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="col__2">
          <img src={contactImg} alt="" className="contact__img" />
        </div>
      </div>
    </div>
  );
};

export default Contact;